<template>
  <aha-dropdown-item-v2
    type="button"
    :class="{ 'disabled': isButtonDisabled, 'is-loading-or-disabled': isLoadingOrDisabled }"
    @click="onImproveWritingButtonClicked(setting.value)"
    class="text-truncate-dropdown-item"
    :title="$i18nPresenter.t(setting.label)"
  >
    <aha-icon class="mb-1 mr-1" :maintainColor="true" :name="setting.nameIcon" />
    {{ $i18nPresenter.t(setting.label) }}
  </aha-dropdown-item-v2>
</template>
<script>
export default {
  props: {
    setting: {
      type: Object,
      default: () => { },
    },
    isDefaultCanvasBlocks: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isButtonDisabled() {
      return this.setting.isDisabled || this.isDefaultCanvasBlocks
    },

    isLoadingOrDisabled() {
      if (!this.setting) return false
      return this.setting.isImprovingSlide || this.isButtonDisabled
    },
  },

  methods: {
    onImproveWritingButtonClicked(settingValue) {
      if (this.isLoadingOrDisabled) return
      this.$emit('onImproveWritingButtonClicked', settingValue)
    },
  },
}
</script>
